import React, { ReactElement } from "react";

type IconProps = {
  width?: number;
  height?: number;
  className?: string;
};

export default function DeleteIcon(props: IconProps): ReactElement {
  const { width = 24, height = 24, className = "" } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17.5198 7.20007H15.5998V6.10447C15.5998 4.16839 14.1149 2.49991 12.1812 2.40463C10.1141 2.30263 8.3998 3.95503 8.3998 6.00007V7.20007H6.4798C5.55196 7.20007 4.7998 7.95223 4.7998 8.88007V10.3201C4.7998 10.5853 5.0146 10.8001 5.2798 10.8001H18.7198C18.985 10.8001 19.1998 10.5853 19.1998 10.3201V8.88007C19.1998 7.95223 18.4476 7.20007 17.5198 7.20007ZM10.7998 6.00007C10.7998 5.33839 11.3381 4.80007 11.9998 4.80007C12.6615 4.80007 13.1998 5.33839 13.1998 6.00007V7.20007H10.7998V6.00007ZM17.9067 13.759L16.8668 19.999C16.8281 20.2304 16.628 20.4001 16.3932 20.4001H7.60636C7.37164 20.4001 7.17148 20.2304 7.13284 19.999L6.09292 13.759C6.0442 13.4665 6.2698 13.2001 6.56644 13.2001H17.4332C17.7298 13.2001 17.9554 13.4665 17.9067 13.759Z"
        fill="#4A4A4A"
      />
    </svg>
  );
}
